<template>
  <page>
    <!-- Keep for further need or enhancement -->
    <!-- <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div> -->
    <v-card>
      <v-card-title>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class=" mr-2" @click="doNew">
          {{ labels.newButton }}
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
      </v-card-title>
      <v-flex xs12>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            v-bind:options.sync="pagination"
            item-key="name"
            :loading="loading"
            :no-data-text="noDataText"
            :custom-filter="customSearch"
          >
            <template v-slot:item="row"
              ><tr>
                <td class="text-xs-left">{{ row.item.paramName }}</td>
                <td class="text-xs-left">{{ row.item.paramRef }}</td>
                <td class="text-xs-left">{{ row.item.paramDesc }}</td>
                <td class="table-action-header">
                  <table-action
                    :rowData="row"
                    review
                    @review="doReview(row.item)"
                    query
                    @query="doQuery(row.item)"
                    remove
                    @remove="doPromptRemove(row.item)"
                  ></table-action>
                </td></tr
            ></template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-card>
    <!--Start Delete Prompt -->
    <confirm v-model="promptRemove" @ok="doDelete">
      <p>{{ labels.promptRemove }}</p>
      <div class="queryValue">{{ selected.paramName }} {{ selected.paramRef }} - {{ selected.paramDesc }}</div>
    </confirm>
    <!-- End Delete Prompt-->
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { motorDataMixin } from '@/mixins/params/motorDataMixin'
import { formatDisplayDate } from '@/utils/date'
// import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      motorParam: 'mtrVehModel',
      headers: [
        { text: 'Model Code', value: 'paramName' },
        { text: 'Make', value: 'paramRef' },
        { text: 'Description', value: 'paramDesc' },
        TableConst.tableActionHeader
      ],
      labels: {
        promptRemove: 'Are you sure you want to delete the selected Motor Standard Text?',
        newButton: 'New Vehicle Model'
      },
      selected: {
        paramName: null,
        paramRef: null,
        paramDesc: null
      },
      promptRemove: false,
      queryMode: false,
      reviewMode: false,
      reviewDialog: false,
      newMode: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  methods: {
    init() {
      this.doInit(this.motorParam)
    },
    doNew() {
      this.resetValidator()
      this.resetMessages()
      this.$router.push({ name: 'mtrVehModelReview', params: { vehMake: 'new', vehModel: 'new', tranMode: 'New' } })
    },
    doQuery(item) {
      this.$router.push({ name: 'mtrVehModelReview', params: { vehMake: item.paramRef, vehModel: item.paramName, tranMode: 'Query' } })
    },
    doReview(item) {
      this.$router.push({ name: 'mtrVehModelReview', params: { vehMake: item.paramRef, vehModel: item.paramName, tranMode: 'Review' } })
    },
    doPromptRemove(item) {
      this.resetValidator()
      this.resetMessages()
      this.selected.paramName = item.paramName
      this.selected.paramDesc = item.paramDesc
      this.selected.paramRef = item.paramRef
      this.promptRemove = true
    },
    async doDelete() {
      this.resetMessages()
      if (this.selected && this.selected.paramName) {
        const apiURI = this.menu.performAction
        if (apiURI) {
          const expand = {
            paramName: this.selected.paramName,
            paramRef: this.selected.paramRef,
            paramType: this.motorParam,
            actionName: 'DELETE'
          }
          this.$http
            .post(apiURI, expand)
            .then((result) => {
              const { data } = result
              this.notify(data)
              this.promptRemove = false
              this.init()
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    }
  },
  created() {
    this.init()
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  mixins: [TableConst.default, motorDataMixin]
}
</script>
